import { useState, useEffect, useContext } from "react";
import { isMobile, isTablet } from "react-device-detect";
import { iconCompresiones } from "../../helpers/ImagesCache";
import CheckCalidadRcp from "../CheckCalidadRcp/CheckCalidadRcp";

import { TimelineContext } from "../../helpers/Context";
import useTranslation from "../../hooks/useTranslation";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogCalidadRcp = ({
  callbackConfirm,
  callbackCancel,
  status,
  actionCalidadRcp,
  volverCalidadRcp,
  saveAnd,
  noBackground,
}) => {
  const T = useTranslation();
  const ctxTimeline = useContext(TimelineContext);
  const [isOpen, setIsOpen] = useState(status);
  const [canContinue, setCanContinue] = useState(false);
  const handlerClose = () => {
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerOnConfirm = () => {
    if (callbackConfirm) {
      callbackConfirm();
    }
    if (actionCalidadRcp) {
      actionCalidadRcp();
    }
  };

  useEffect(() => {
    setIsOpen(status);
  }, [status]);

  const refreshContext = () => {
    const haveAnNull = ctxTimeline.rcpQuality.filter(
      (item) => item.selectedOption == null
    );
    if (haveAnNull.length == 0) {
      setCanContinue(true);
    } else {
      setCanContinue(false);
    }

    console.log(
      "%cContexto en Dialog rcpQuality Refresh context",
      "color:purple",
      ctxTimeline.rcpQuality
    );
  };

  return (
    <>
      <FloatingDialog
        isOpen={isOpen}
        onClose={handlerClose}
        noBackground={noBackground}
        variant="bottom"
      >
        <div className="w-full flex flex-col max-h-[80vh]">
          {/* Header */}
          <div className="flex flex-row items-center ml-8">
            <img src={iconCompresiones} />
            <h4 className="text-2xl font-bold text-[#000e] p-4">
              {T("Calidad RCP")}
            </h4>
          </div>

          {/* Scrollable List */}
          <div className="flex-1 overflow-y-auto">
            {ctxTimeline.rcpQuality.map((item) => (
              <CheckCalidadRcp
                key={item.object}
                titulo={T(item.title)}
                desripcion={T(item.description)}
                object={item.object}
                options={item.options}
                selectedOption={item.selectedOption}
                onChange={() => {
                  refreshContext();
                }}
              />
            ))}
          </div>

          {/* Divider */}
          <div className="bg-[#DAD9DB] h-[1px]" />

          {/* Fixed Footer */}
          <div className="h-32 w-full flex justify-center items-center gap-6 bg-white shrink-0">
            <SimpleButton
              text={T("back")}
              onClick={volverCalidadRcp}
              variant="gray"
            />
            <SimpleButton
              text={T(isTablet ? saveAnd : "save")}
              onClick={handlerOnConfirm}
              disabled={!canContinue}
            />
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogCalidadRcp;
